import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { InputComponent } from "@components/input/input.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { MeddelandeInfotavlaDTO } from "~app/common/models/meddelandeInfotavla/MeddelandeInfotavlaDTO";
import { CommonTexts } from "~app/common/texts/common.texts";
import { DateUtils as dateUtils } from "~app/common/utils/date-utils";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { SystemaktivitetService } from "~app/features/administration/systemaktivitet/systemaktivitet.service";

@Component({
    selector: "rask-laggtill-systemaktivitet",
    templateUrl: "./laggtill-systemaktivitet.component.html",
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DatepickerComponent,
        InputComponent,
        TextareaComponent,
        SaveButtonComponent,
        ButtonComponent
    ]
})
export class LaggtillSystemaktivitetComponent implements OnInit {
    commonTexts = CommonTexts.texts;
    data: any;
    editForm = new UntypedFormGroup({});
    modal = inject(NgbActiveModal);
    systemaktivitet: MeddelandeInfotavlaDTO;
    validationContext: IValidationContext;

    private readonly busyService = inject(BusyService);
    private readonly systemaktivitetService = inject(SystemaktivitetService);

    dismiss() {
        this.modal.close();
    }

    mapFromModel(systemaktivitet: MeddelandeInfotavlaDTO) {
        this.editForm = new UntypedFormGroup({
            datumFran: new UntypedFormControl(systemaktivitet.datumFran),
            datumTill: new UntypedFormControl(systemaktivitet.datumTill),
            rubrik: new UntypedFormControl(systemaktivitet.rubrik),
            meddelande: new UntypedFormControl(systemaktivitet.meddelande)
        });
        this.editForm.markAsPristine();
    }

    ngOnInit() {
        this.systemaktivitet = this.data;
        this.mapFromModel(this.systemaktivitet);
    }

    save() {
        if (this.editForm.valid) {
            if (this.systemaktivitet.id) {
                this.update();
            } else {
                this.create();
            }
        }
    }

    private create(): void {
        const worker: Observable<MeddelandeInfotavlaDTO> = this.busyService.addWork(this.systemaktivitetService.createSystemaktivitet(this.mapFromForm())) as any;
        worker.subscribe(
            {
                next: result => {
                    this.editForm.markAsPristine();
                    this.modal.close(result);
                },
                error: (error) => {
                    //
                }
            }
        );
    }

    private mapFromForm(): MeddelandeInfotavlaDTO {
        return {
            datumFran: this.editForm.get("datumFran").value,
            datumTill: dateUtils.endOfDay(this.editForm.get("datumTill").value),
            rubrik: this.editForm.get("rubrik").value,
            meddelande: this.editForm.get("meddelande").value,
            id: this.systemaktivitet.id
        } as MeddelandeInfotavlaDTO;
    }

    private update(): void {
        const worker: Observable<MeddelandeInfotavlaDTO> = this.busyService.addWork(this.systemaktivitetService.updateSystemaktivitet(this.mapFromForm())) as any;
        worker.subscribe(
            {
                next: result => {
                    this.editForm.markAsPristine();
                    this.modal.close(result);
                },
                error: (error) => {
                    //
                }
            }
        );
    }
}
